import { Component } from '@angular/core';
import {
  DateRange,
  DateRangePickerComponent,
  ErrorComponent,
} from '@group24ag/flowkit';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';

@Component({
  imports: [
    DateRangePickerComponent,
    ErrorComponent,
    FormsModule,
    ReactiveFormsModule,
  ],
  selector: 'app-ui-date-range-picker',
  template: `
    <div class="max-w-96">
      <h1 class="heading-title">Date Range Picker</h1>
      <div class="flex flex-col gap-10">
        <flk-date-range-picker
          class="w-full"
          [(ngModel)]="simpleRange"
          [label]="'Date Range'"
          [placeholder]="'Select a range'" />
        <flk-date-range-picker
          class="w-full"
          [formControl]="requiredControl"
          [label]="'Required range'"
          [placeholder]="'Pick a range'">
          <flk-error>Range is required</flk-error>
        </flk-date-range-picker>
        <flk-date-range-picker
          class="w-full"
          [formControl]="disabledControl"
          [label]="'Disabled'"
          [placeholder]="'Pick a range'" />
        <flk-date-range-picker
          class="w-full"
          [formControl]="constrainedControl"
          [label]="'With min/max (today ± 30 days)'"
          [placeholder]="'Pick within range'"
          [min]="minDate"
          [max]="maxDate" />
      </div>
    </div>
  `,
})
export class UIDateRangePickerComponent {
  /** Simple two-way binding example **/
  simpleRange: DateRange = { start: null, end: null };

  /** Required form control to showcase validation **/
  readonly requiredControl = new FormControl<DateRange>(
    { start: null, end: null },
    [Validators.required]
  );

  /** Pre-filled disabled control **/
  readonly disabledControl = new FormControl<DateRange>({
    value: {
      start: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000),
      end: new Date(Date.now() + 3 * 24 * 60 * 60 * 1000),
    },
    disabled: true,
  });

  /** Control with min/max constraints **/
  readonly constrainedControl = new FormControl<DateRange>({
    start: null,
    end: null,
  });

  /** Earliest selectable date: 30 days ago **/
  readonly minDate = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000);

  /** Latest selectable date: 30 days from now **/
  readonly maxDate = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
}
